/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetUserWalletDetailPageListRespVo
 */
export interface GetUserWalletDetailPageListRespVo {
    /**
     * No
     * @type {number}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    id?: number;
    /**
     * 使用区分编号
     * @type {number}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    usedType?: number;
    /**
     * 使用区分名称
     * @type {string}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    usedTypeName?: string;
    /**
     * 用户id
     * @type {number}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    userId?: number;
    /**
     * 用户名称
     * @type {string}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    userName?: string;
    /**
     * 钱包类型：1-韩国钱包，2-中国账单钱包
     * @type {number}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    walletType?: number;
    /**
     * 内容
     * @type {string}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    remark?: string;
    /**
     * 出金入金类型  0 出金，1 入金
     * @type {number}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    intOutType?: number;
    /**
     * 金额
     * @type {number}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    amount?: number;
    /**
     * 出入金之后的钱包元素金额
     * @type {number}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    principal?: number;
    /**
     * 创建时间
     * @type {string}
     * @memberof GetUserWalletDetailPageListRespVo
     */
    createTime?: string;
}

/**
 * Check if a given object implements the GetUserWalletDetailPageListRespVo interface.
 */
export function instanceOfGetUserWalletDetailPageListRespVo(value: object): value is GetUserWalletDetailPageListRespVo {
    return true;
}

export function GetUserWalletDetailPageListRespVoFromJSON(json: any): GetUserWalletDetailPageListRespVo {
    return GetUserWalletDetailPageListRespVoFromJSONTyped(json, false);
}

export function GetUserWalletDetailPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUserWalletDetailPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'usedType': json['usedType'] == null ? undefined : json['usedType'],
        'usedTypeName': json['usedTypeName'] == null ? undefined : json['usedTypeName'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'walletType': json['walletType'] == null ? undefined : json['walletType'],
        'remark': json['remark'] == null ? undefined : json['remark'],
        'intOutType': json['intOutType'] == null ? undefined : json['intOutType'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'principal': json['principal'] == null ? undefined : json['principal'],
        'createTime': json['createTime'] == null ? undefined : json['createTime'],
    };
}

export function GetUserWalletDetailPageListRespVoToJSON(json: any): GetUserWalletDetailPageListRespVo {
    return GetUserWalletDetailPageListRespVoToJSONTyped(json, false);
}

export function GetUserWalletDetailPageListRespVoToJSONTyped(value?: GetUserWalletDetailPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'usedType': value['usedType'],
        'usedTypeName': value['usedTypeName'],
        'userId': value['userId'],
        'userName': value['userName'],
        'walletType': value['walletType'],
        'remark': value['remark'],
        'intOutType': value['intOutType'],
        'amount': value['amount'],
        'principal': value['principal'],
        'createTime': value['createTime'],
    };
}

